module.exports = __webpack_public_path__ + "static/media/dark-alice-logo-full.0382488a.svg";